<script lang="ts">
	let { visible, class: classes = '' } = $props();

	let videoEl = $state<HTMLVideoElement>();

	$effect(() => {
		if (!videoEl) return;
		if (visible) videoEl.play();
		if (!visible) videoEl.pause();
	});
</script>

<div
	class={[
		'fixed inset-8 z-50 flex flex-col items-center justify-center overflow-hidden transition-all duration-700',
		visible ? 'opacity-100' : 'translate-y-10 opacity-0',
		classes
	]}
>
	<video
		bind:this={videoEl}
		src="/traffic.mp4"
		class="min-h-[600px] w-full object-cover"
		muted
		loop
		playsinline
	></video>
</div>
